package com.essntl.features.organization.data.repository

import com.essntl.features.organization.data.supabase.toDto
import com.essntl.features.organization.domain.model.OrganizationModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun OrganizationModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["name"] = JsonPrimitive(name)

    address?.id?.let { id ->
        requestMap["address_id"] = JsonPrimitive(id)
    }

    website?.let {
        requestMap["website"] = JsonPrimitive(it)
    }

    notes?.let {
        requestMap["notes"] = JsonPrimitive(it)
    }

    parentId?.let { id ->
        requestMap["parent_id"] = JsonPrimitive(id)
    }

    type?.let { t ->
        requestMap["type"] = JsonPrimitive(t.toDto())
    }

    logoFileId?.let { requestMap["logo_file_id"] = JsonPrimitive(it.ifBlank { null }) }

    return requestMap
}